"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TouristsPickerOld = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _memoize2 = _interopRequireDefault(require("lodash/memoize"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _localization = require("@lt/localization");
var _CounterPluralize = _interopRequireDefault(require("../CounterPluralize"));
var _SearcherDropdown = _interopRequireDefault(require("../SearcherDropdown"));
var _pluralizeUtils = require("../../utils/pluralizeUtils");
var _rebrand = require("../../icons-react/rebrand");
var _excluded = ["open", "kidsValue", "value", "onChange", "minValue", "maxValue", "minChildAge", "maxChildAge", "maxChildren"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var StyledInput = _styledComponents["default"].div.withConfig({
  displayName: "TouristsPickerOld__StyledInput",
  componentId: "sc-epcj4q-0"
})(["display:flex;align-items:baseline;"]);
var StyledCounterPluralize = (0, _styledComponents["default"])(_CounterPluralize["default"]).withConfig({
  displayName: "TouristsPickerOld__StyledCounterPluralize",
  componentId: "sc-epcj4q-1"
})(["height:50px;box-shadow:var(--box-shadow);padding:0 10px;"]);
var StyledIcon = _styledComponents["default"].span.withConfig({
  displayName: "TouristsPickerOld__StyledIcon",
  componentId: "sc-epcj4q-2"
})(["height:25px;min-width:25px;height:25px;display:inline-flex;justify-content:center;align-items:center;"]);
var StyledKids = _styledComponents["default"].ul.withConfig({
  displayName: "TouristsPickerOld__StyledKids",
  componentId: "sc-epcj4q-3"
})(["box-shadow:inset 0 -1px 0 #c2c5cc;"]);
var StyledAddChildButton = _styledComponents["default"].span.withConfig({
  displayName: "TouristsPickerOld__StyledAddChildButton",
  componentId: "sc-epcj4q-4"
})(["font-size:14px;color:", ";display:inline-flex;justify-content:center;align-items:center;"], function (props) {
  return props.theme.colors.blue;
});
var StyledAddChild = _styledComponents["default"].div.withConfig({
  displayName: "TouristsPickerOld__StyledAddChild",
  componentId: "sc-epcj4q-5"
})(["position:relative;height:50px;display:flex;justify-content:center;align-items:center;"]);
var StyledSelect = _styledComponents["default"].select.withConfig({
  displayName: "TouristsPickerOld__StyledSelect",
  componentId: "sc-epcj4q-6"
})(["cursor:pointer;left:0;height:100%;opacity:0;position:absolute;top:0;width:100%;-webkit-appearance:none;"]);
var StyledKidsItem = _styledComponents["default"].div.withConfig({
  displayName: "TouristsPickerOld__StyledKidsItem",
  componentId: "sc-epcj4q-7"
})(["display:flex;justify-content:center;align-items:center;height:50px;font-size:14px;color:", ";> span{color:", ";}"], function (props) {
  return props.theme.colors.blackLight;
}, function (props) {
  return props.theme.colors.blackBase;
});
var InputRenderer = function InputRenderer(_ref) {
  var value = _ref.value;
  return /*#__PURE__*/_react["default"].createElement(StyledInput, null, (0, _pluralizeUtils.pluralizeAdults)(value));
};
InputRenderer.propTypes = {
  value: _propTypes["default"].number.isRequired
};

/**
 * Генерирует необходимое количество option
 * @param {number} minAge
 * @param {number} maxAge
 */
var makeOptions = function makeOptions(minAge, maxAge) {
  var arraySize = maxAge - minAge + 1;
  return new Array(arraySize).fill(null).map(function (item, index) {
    var value = minAge + index;
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: value,
      value: value
    }, "".concat(value, " ").concat((0, _pluralizeUtils.pluralizeYears)(value)));
  });
};
var makeOptionsMemoized = (0, _memoize2["default"])(makeOptions);
var TouristsPickerOld = exports.TouristsPickerOld = /*#__PURE__*/function (_React$PureComponent) {
  function TouristsPickerOld(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, TouristsPickerOld);
    _this = _callSuper(this, TouristsPickerOld, [props]);
    _this.state = {
      childrenValue: -1
    };
    _this.handleAddChildren = _this.handleAddChildren.bind(_this);
    _this.handleRemoveChildren = _this.handleRemoveChildren.bind(_this);
    _this.handleChangeKids = _this.handleChangeKids.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(TouristsPickerOld, _React$PureComponent);
  return (0, _createClass2["default"])(TouristsPickerOld, [{
    key: "handleChangeKids",
    value: function handleChangeKids(value) {
      var onChangeKids = this.props.onChangeKids;
      this.setState({
        childrenValue: -1
      }, function () {
        onChangeKids(value);
      });
    }
  }, {
    key: "handleAddChildren",
    value: function handleAddChildren(_ref2) {
      var target = _ref2.target;
      var value = target.value;
      var kidsValue = this.props.kidsValue;
      var newKidsValue = kidsValue.concat(parseInt(value, 10));
      this.handleChangeKids(newKidsValue);
    }
  }, {
    key: "handleRemoveChildren",
    value: function handleRemoveChildren(_ref3) {
      var target = _ref3.target;
      var index = target.dataset.index;
      var kidsValue = this.props.kidsValue;
      var newKidsValue = kidsValue.filter(function (val, idx) {
        return idx !== parseInt(index, 10);
      });
      this.handleChangeKids(newKidsValue);
    }
  }, {
    key: "touristsLabel",
    get: function get() {
      var _this$props = this.props,
        kidsValue = _this$props.kidsValue,
        value = _this$props.value;
      var kidsCount = kidsValue.length;
      // TODO: в будущем планируется выводить текст вида "2 взрослых, 1 ребёнок"
      // const adult = `${value} ${pluralize(value, text)}`;
      // const kids = kidsCount > 0 ? `, ${kidsCount} ${pluralize(kidsCount, childrenText)}` : '';
      // return adult + kids;
      return kidsCount > 0 ? "".concat(value + kidsCount, " ").concat((0, _pluralizeUtils.pluralizePerson)(value + kidsCount)) : "".concat(value, " ").concat((0, _pluralizeUtils.pluralizeAdults)(value));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        open = _this$props2.open,
        kidsValue = _this$props2.kidsValue,
        value = _this$props2.value,
        onChange = _this$props2.onChange,
        minValue = _this$props2.minValue,
        maxValue = _this$props2.maxValue,
        minChildAge = _this$props2.minChildAge,
        maxChildAge = _this$props2.maxChildAge,
        maxChildren = _this$props2.maxChildren,
        props = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded);
      var childrenValue = this.state.childrenValue;
      var kidsCount = kidsValue.length;
      return /*#__PURE__*/_react["default"].createElement(_SearcherDropdown["default"], (0, _extends2["default"])({
        labelContent: /*#__PURE__*/_react["default"].createElement(StyledInput, null, this.touristsLabel),
        open: open
      }, props), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledCounterPluralize, {
        value: value,
        text: [_localization.i18n.t('touristsPicker.adult', {
          count: 1
        }), _localization.i18n.t('touristsPicker.adult', {
          count: 2
        }), _localization.i18n.t('touristsPicker.adult', {
          count: 2
        })],
        onChange: onChange,
        minValue: minValue,
        maxValue: maxValue
      }), kidsCount > 0 && /*#__PURE__*/_react["default"].createElement(StyledKids, null, kidsValue.map(function (item, index) {
        var key = "".concat(item, "-").concat(item + index);
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: key
        }, /*#__PURE__*/_react["default"].createElement(StyledKidsItem, null, _localization.i18n.t('touristsPicker.child'), " \xB7 \xA0", /*#__PURE__*/_react["default"].createElement("span", null, "".concat(item, " ").concat((0, _pluralizeUtils.pluralizeYears)(item))), /*#__PURE__*/_react["default"].createElement(StyledIcon, {
          as: "button",
          "data-index": index,
          onClick: _this2.handleRemoveChildren
        }, /*#__PURE__*/_react["default"].createElement(_rebrand.XMark, {
          height: 20
        }))));
      })), kidsCount < maxChildren && /*#__PURE__*/_react["default"].createElement(StyledAddChild, null, /*#__PURE__*/_react["default"].createElement(StyledAddChildButton, null, /*#__PURE__*/_react["default"].createElement(StyledIcon, null, /*#__PURE__*/_react["default"].createElement(_rebrand.Plus, {
        height: 20
      })), _localization.i18n.t('touristsPicker.addChild')), /*#__PURE__*/_react["default"].createElement(StyledSelect, {
        onChange: this.handleAddChildren,
        value: childrenValue
      }, /*#__PURE__*/_react["default"].createElement("option", {
        value: "-1",
        disabled: true
      }, _localization.i18n.t('touristsPicker.ageOld')), makeOptionsMemoized(minChildAge, maxChildAge)))));
    }
  }]);
}(_react["default"].PureComponent);
TouristsPickerOld.propTypes = {
  className: _propTypes["default"].string,
  minValue: _propTypes["default"].number,
  maxValue: _propTypes["default"].number,
  maxChildren: _propTypes["default"].number,
  minChildAge: _propTypes["default"].number,
  maxChildAge: _propTypes["default"].number,
  open: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  onChangeKids: _propTypes["default"].func,
  value: _propTypes["default"].number.isRequired,
  kidsValue: _propTypes["default"].arrayOf(_propTypes["default"].number.isRequired)
};
TouristsPickerOld.defaultProps = {
  className: '',
  kidsValue: [],
  minValue: 1,
  maxValue: 4,
  maxChildren: 3,
  minChildAge: 0,
  maxChildAge: 17,
  open: false,
  onChange: Function.prototype,
  onChangeKids: Function.prototype
};
TouristsPickerOld.KidsItem = StyledKidsItem;
TouristsPickerOld.AddChild = StyledAddChild;